import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { ImagePlaceholder } from './ImagePlaceholder';
const testimonios = [{
  initial: 'S',
  name: 'Silvana M., Córdoba',
  title: 'Por fin algo que ataca el problema de verdad',
  body: 'Tengo 47 años y probé todo. Dietas, batidos, pastillas. Nada me duraba más de un mes. Con ESBELTA en la segunda semana noté que la panza estaba más blanda, menos dura. La tercera semana mi marido me preguntó si había bajado de peso. Y yo solo había cambiado las gomitas.',
  imgLabel: 'Silvana, mujer 45+, cabello castaño, sosteniendo pote ESBELTA',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/mtcCfF3DsyV9d24sCNmNXS/heylloyd-image-1781551227849.png'
}, {
  initial: 'R',
  name: 'Romina P., Buenos Aires',
  title: 'Los antojos desaparecieron y no entiendo cómo',
  body: 'Siempre a las 4 de la tarde caía en el chocolate o las galletitas. No podía evitarlo. Desde que empecé ESBELTA esos antojos simplemente... no llegan. Me siento más pareja durante todo el día. Nunca esperé que una gomita me cambiara el día así.',
  imgLabel: 'Romina, mujer 38+, rubia, en cocina natural',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/kSjWxDm6vWxh36R3b5Kdxk/8d37ee75-d4e5-4988-96a7-ab7350538b40.png'
}, {
  initial: 'C',
  name: 'Claudia V., Rosario',
  title: 'Pensé que era la menopausia. Era el cortisol.',
  body: 'Me pasé dos años pensando que la hinchazón y el cansancio eran "cosas de la edad". Empecé ESBELTA casi sin fe. A los 10 días me desperté diferente. Más liviana, más descansada, menos hinchada. Ahora les digo a todas mis amigas.',
  imgLabel: 'Claudia, mujer 52+, morena, sonriendo confiada',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/nesYsUFseKDHHFXEgRGorL/heylloyd-image-1781551490752.png'
}];
export function Testimonios() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-278">
      <div className="max-w-6xl mx-auto" data-id="element-279">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-280">
          Lo que dicen las mujeres que probaron ESBELTA®
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-281">
          {testimonios.map((test, idx) => <div key={idx} className="bg-esbelta-lavender/40 rounded-2xl p-6 border border-esbelta-violet/10 flex flex-col" data-id="element-282">
              <div className="aspect-square w-full rounded-xl overflow-hidden mb-6 bg-white" data-id="element-283">
                {test.imgSrc ? <img src={test.imgSrc} alt={test.imgLabel} className="w-full h-full object-cover" data-id="element-284" /> : <ImagePlaceholder label={test.imgLabel} className="w-full h-full" data-id="element-285" />}
              </div>

              <div className="flex items-center gap-3 mb-4" data-id="element-286">
                <div className="w-10 h-10 rounded-full bg-esbelta-lavender text-esbelta-violet font-bold flex items-center justify-center flex-shrink-0" data-id="element-287">
                  {test.initial}
                </div>
                <div data-id="element-288">
                  <div className="font-bold text-gray-900 text-sm" data-id="element-289">
                    {test.name}
                  </div>
                  <div className="text-green-600 text-xs font-medium flex items-center gap-1" data-id="element-290">
                    <CircleCheckIcon className="w-3 h-3" data-id="element-291" /> Compra verificada
                  </div>
                </div>
              </div>

              <h3 className="font-serif text-xl font-bold text-gray-900 mb-3" data-id="element-292">
                "{test.title}"
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed flex-grow" data-id="element-293">
                {test.body}
              </p>
            </div>)}
        </div>

        <div className="mt-12 flex flex-col items-center text-center" data-id="element-294">
          <p className="text-gray-600 text-sm md:text-base mb-4 max-w-md" data-id="element-295">
            Sumate a las miles de mujeres que ya recuperaron su equilibrio con
            ESBELTA®.
          </p>
          <a href="#ofertas" className="inline-block bg-esbelta-violet hover:bg-esbelta-dark text-white font-bold text-lg py-4 px-10 rounded-xl transition-colors shadow-lg shadow-esbelta-violet/20" data-id="element-296">
            QUIERO MI ESBELTA®
          </a>
        </div>
      </div>
    </section>;
}